import { BybTextFieldAlt } from '@Components/game/common';
import Icon from '@Components/generic/icon';
import { faSearch, faXmark } from '@fortawesome/pro-solid-svg-icons';
import useI18n from '@i18n';
import { useMediaQuery, useTheme } from '@mui/material';

interface ProfileSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onClear: () => void;
}

const ProfileSearch = ({ searchTerm, onSearchChange, onClear }: ProfileSearchProps) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const fontSize = isSmDown ? 16 : 24;

  return (
    <BybTextFieldAlt
      fullWidth
      placeholder={i18n('account.profile.selection.search.placeholder')}
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      InputProps={{
        sx: {
          height: theme.spacing(6),
          '& input': {
            padding: theme.spacing(2),
            fontSize: theme.spacing(2),
            '&::placeholder': {
              fontSize: theme.spacing(2),
            },
          },
        },
        startAdornment: (
          <Icon
            icon={faSearch}
            sx={{
              color: 'dsNeutral.v300',
              ml: 1.5,
              mr: 1,
            }}
            fontSize={fontSize}
          />
        ),
        endAdornment: searchTerm && (
          <Icon
            icon={faXmark}
            sx={{
              color: 'dsNeutral.v300',
              cursor: 'pointer',
              '&:hover': {
                color: 'dsNeutral.v200',
              },
            }}
            fontSize={fontSize}
            onClick={onClear}
          />
        ),
      }}
    />
  );
};

export default ProfileSearch;
